import React from "react";
import PropTypes from "prop-types";
import $ from "jquery";
import JSON5 from "json5";
import moment from "moment";
import { connect } from "react-redux";
import Loader from "../Loader";
import ErrorMessage from "../ErrorMessage";
import { fetch, setLimit, setParam } from "../../redux/query";
import { merge } from "../../redux/settings";
import { parseQueryString } from "../../lib";
import { Outlet, useNavigate } from "react-router-dom";
import "./App.less";
import defaultConfig from "../../config/default.js";

const OWNER = window.opener || (window.parent === self ? null : window.parent);
const DEFAULT_CONFIG = "default";

export class App extends React.Component {
    static propTypes = {
        settings: PropTypes.object.isRequired,
        query: PropTypes.object,
        dispatch: PropTypes.func.isRequired
    };

    constructor(...args) {
        super(...args);
        this.state = {
            error: null
        };
    }

    dispatchInitialFetch = () => {
        const currentPath = window.location.pathname || "";
        const isPatientListRoute = /^\/patient-list(?:\?|$)/.test(currentPath);
        const hasDateFilter = !!(
            this.props.query &&
            this.props.query.params &&
            (this.props.query.params.lastUpdatedFrom || this.props.query.params.lastUpdatedTo)
        );
        const isAdvanced = this.props.query && this.props.query.queryType === "advanced";

        if (!hasDateFilter && !isAdvanced) {
            const startDate = moment().subtract(29, "days").format("YYYY-MM-DD");
            const endDate = moment().format("YYYY-MM-DD");

            // this.props.dispatch(setParam({
            //     name: "lastUpdatedFrom",
            //     value: startDate
            // }));
            // this.props.dispatch(setParam({
            //     name: "lastUpdatedTo",
            //     value: endDate
            // }));
        }

        // Patient FHIR search is only needed on Demographics / patient-list.
        // Running it on leads-summary (and other) deep links can 401 and bounce
        // users to /login → default /patient-list?_tab=demographics.
        if (!isPatientListRoute) {
            return;
        }

        this.props.dispatch(fetch());
    };

    handleUiBlocking() {
        let runningRequests = 0, hideDelay;

        const handle = () => {
            if (hideDelay) {
                clearTimeout(hideDelay);
            }
            if (runningRequests > 0) {
                $("#overlay").show();
            } else {
                hideDelay = setTimeout(() => {
                    $("#overlay").hide();
                }, 200);
            }
        };

        $(document).ajaxStart(() => {
            runningRequests++;
            handle();
        });

        $(document).ajaxComplete(() => {
            runningRequests = Math.max(--runningRequests, 0);
            handle();
        });
    }

    // componentDidMount() {
    //     this.handleUiBlocking();

    //     let { config, ...params } = parseQueryString(window.location.search);

    //     let settings = {};
    //     $.ajax({
    //         url: `./config/${config || DEFAULT_CONFIG}.json5`,
    //         dataType: "text",
    //         cache: false
    //     })
    //         .then(
    //             json => {
    //                 json = JSON5.parse(json);
    //                 $.ajaxSetup({ timeout: json.timeout || 20000 });
    //                 settings = { ...json, ...params };
    //             },
    //             errorXHR => {
    //                 console.warn("Loading custom config: " + errorXHR.statusText);
    //             }
    //         )
    //         .always(() => {
    //             let settingReceived = false;

    //             const onMessage = e => {
    //                 if (
    //                     e.data.type === "config" &&
    //                     e.data.data &&
    //                     typeof e.data.data === "object"
    //                 ) {
    //                     settingReceived = true;
    //                     this.props.dispatch(merge(e.data.data));
    //                     this.props.dispatch(fetch());
    //                 }
    //             };

    //             this.props.dispatch(merge(settings));
    //             this.props.dispatch(setLimit(settings.patientsPerPage));

    //             if (OWNER) {
    //                 window.addEventListener("unload", function () {
    //                     OWNER.postMessage({ type: "close" }, "*");
    //                 });

    //                 window.addEventListener("message", onMessage);

    //                 setTimeout(() => {
    //                     window.removeEventListener("message", onMessage);
    //                     if (!settingReceived) {
    //                         this.props.dispatch(fetch());
    //                     }
    //                 }, 1000);

    //                 OWNER.postMessage({ type: "ready" }, "*");
    //             } else {
    //                 this.props.dispatch(fetch());
    //             }
    //         });
    // }
    componentDidMount() {
        this.handleUiBlocking();

        let { config, ...params } = parseQueryString(window.location.search);
        let configName = config || DEFAULT_CONFIG;

        let settings = {};

        const loadConfig = async () => {
            // ✔ If config = "default", load the JS version (with env variables)
            if (configName === DEFAULT_CONFIG) {
                console.log("Using JS default config with ENV variables");
                settings = { ...defaultConfig, ...params };
                $.ajaxSetup({ timeout: settings.timeout || 20000 });
                return;
            }

            // ✔ Otherwise, load JSON5 from public folder (old behavior)
            console.log(`Loading JSON5 config: ${configName}`);
            try {
                const jsonText = await $.ajax({
                    url: `./config/${configName}.json5`,
                    dataType: "text",
                    cache: false
                });
                const json = JSON5.parse(jsonText);

                settings = { ...json, ...params };
                $.ajaxSetup({ timeout: json.timeout || 20000 });
            } catch (errorXHR) {
                console.warn("Loading custom config failed:", errorXHR.statusText);
            }
        };

        loadConfig().finally(() => {
            let settingReceived = false;

            const onMessage = (e) => {
                if (
                    e.data.type === "config" &&
                    e.data.data &&
                    typeof e.data.data === "object"
                ) {
                    settingReceived = true;
                    this.props.dispatch(merge(e.data.data));
                    this.dispatchInitialFetch();
                }
            };

            // Merge settings
            this.props.dispatch(merge(settings));
            this.props.dispatch(setLimit(settings.patientsPerPage));

            if (OWNER) {
                window.addEventListener("unload", () => {
                    OWNER.postMessage({ type: "close" }, "*");
                });

                window.addEventListener("message", onMessage);

                setTimeout(() => {
                    window.removeEventListener("message", onMessage);
                    if (!settingReceived) {
                        this.dispatchInitialFetch();
                    }
                }, 1000);

                OWNER.postMessage({ type: "ready" }, "*");
            } else {
                this.dispatchInitialFetch();
            }
        });
    }


    render() {
        if (this.state.error) {
            return <ErrorMessage error={this.state.error} />;
        }
        if (!this.props.settings || !this.props.settings.loaded) {
            return (
                <div className="app">
                    <Loader />
                </div>
            );
        }
        return (
            <div className="app">
                {/* This will render the nested route component */}
                <Outlet />
            </div>
        );
    }
}

export default connect(state => ({ ...state }))(App);
